import React from "react"
import { Alert } from "antd"
import { useDummyData } from "../api/useDummyData"

interface Props {
  projectId?: string
  className?: string
}

/** In an export dialog: says the export is made from dummy data, while it is. */
const DummyNotice: React.FC<Props> = ({ projectId, className }) => {
  const { isActive } = useDummyData(projectId)
  if (!isActive) return null
  return (
    <Alert
      type="warning"
      showIcon
      className={className}
      data-testid="dummy-notice"
      message="This export is made from dummy data, generated for testing."
    />
  )
}

export default DummyNotice
